// extracted by mini-css-extract-plugin
module.exports = {"Countdown":"countDown-module--Countdown--2Fneh","CountdownCol":"countDown-module--CountdownCol--2sWm2","CountdownColElement":"countDown-module--CountdownColElement--3Shm-"};